module.exports = __webpack_public_path__ + "img/qt-06.a24af2e5.png";